export const INITIAL_STATE = {
  eventId: 0,
  name: null,
  startDate: null,
  endDate: null,
  category: null,
  subCategory: null,
  structure: [],
  reportFilters: [],
  reportSelectedFilters: [],
  stageReportSelectedStage: null,
  teamStageReportSelectedStage: null,
  teamProperties: null,
  teamsReportFilters: [],
  teamsReportSelectedFilters: [],
  availableWidgets: [],
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "UPDATE_EVENT_DETAILS": {
      return {
        ...state,
        eventId: action.payload.eventId,
        name: action.payload.name,
        startDate: action?.payload?.startDate,
        endDate: action?.payload?.endDate,
        edition: action?.payload?.edition,
      };
    }
    case "UPDATE_EVENT_CATEGORY": {
      return { ...state, category: action.payload };
    }
    case "UPDATE_EVENT_SUB_CATEGORY": {
      return { ...state, subCategory: action.payload };
    }
    case "RESET_EVENT_DETAILS": {
      return { ...INITIAL_STATE };
    }
    case "UPDATE_STRUCTURE": {
      return { ...state, structure: action.payload };
    }
    case "UPDATE_REPORTS_FILTERS": {
      return { ...state, reportFilters: action.payload };
    }
    case "UPDATE_SELECTED_REPORT_FILTERS": {
      return { ...state, reportSelectedFilters: action.payload };
    }
    case "UPDATE_SELECTED_REPORT_FILTERS_WITH_EXISTING": {
      // preventFilterReset use this flag to prevent a reset
      const oldFilters = state?.reportSelectedFilters;
      const payload = action.payload;
      let newFilters = [...payload];
      if (
        oldFilters &&
        oldFilters?.length > 0 &&
        (!payload || payload?.length < 1)
      ) {
        newFilters = [...oldFilters];
      } else if (
        oldFilters &&
        oldFilters?.length > 0 &&
        payload &&
        payload?.length > 0
      ) {
        oldFilters.forEach((filterItem) => {
          const oldFilterType = filterItem?.type;
          const found = payload.find(
            (payloadItem) => oldFilterType == payloadItem?.type
          );
          if (found) {
            // comment to prevent linting error
          } else {
            newFilters.push(filterItem);
          }
        });
      }
      const newSelectedFilters = [...newFilters];
      return {
        ...state,
        reportSelectedFilters: newSelectedFilters,
      };
    }
    case "UPDATE_REPORTS_SELECTED_STAGE": {
      return { ...state, stageReportSelectedStage: action.payload };
    }
    case "UPDATE_TEAMS_PROPERTIES": {
      return { ...state, teamProperties: action.payload };
    }
    case "UPDATE_TEAMS_REPORTS_FILTERS": {
      return { ...state, teamsReportFilters: action.payload };
    }
    case "UPDATE_SELECTED_TEAMS_REPORT_FILTERS": {
      return { ...state, teamsReportSelectedFilters: action.payload };
    }
    case "UPDATE_REPORTS_SELECTED_TEAM_STAGE": {
      return { ...state, teamStageReportSelectedStage: action.payload };
    }
    case "UPDATE_AVAILABLE_WIDGETS": {
      return { ...state, availableWidgets: action.payload };
    }
    case "PREVENT_RESET_ALL_FILTERS": {
      return { ...state, preventFilterReset: action.payload };
    }
    case "RESET_ALL_FILTERS": {
      let newState = {};
      if (!state?.preventFilterReset) {
        newState = {
          ...state,
          reportFilters: [],
          reportSelectedFilters: [],
          teamsReportFilters: [],
          teamsReportSelectedFilters: [],
        };
      } else {
        newState = {
          ...state,
        };
      }
      return newState;
    }
    default: {
      return state;
    }
  }
};
